(()=>{
  const api=()=>window.TwoInOneFlagSearch;
  const DESIGN_LABEL='Design your own flag';

  function closeSearch(root){
    root.closest('details-modal')?.close?.(false);
  }

  function goResults(root,query,fallbackHref){
    const q=String(query||'').trim();
    if(!q&&!fallbackHref)return;
    closeSearch(root);
    window.location.assign(fallbackHref||api()?.searchUrl(q,root?.dataset.search||'/search')||`/search?q=${encodeURIComponent(q)}`);
  }

  function thumbMarkup(src,sports){
    return `<img class="hfs__thumb${sports?' is-sports':''}" src="${api().escapeHtml(src)}" alt="" width="40" height="26" loading="lazy" onerror="this.style.visibility='hidden'">`;
  }

  function designButton(index){
    return `<button type="button" class="hfs__design" data-hfs-action="design" data-hfs-index="${index}">${DESIGN_LABEL}</button>`;
  }

  function articleThumb(item,search){
    if(item.image)return `<img class="hfs__thumb" src="${search.escapeHtml(item.image)}" alt="" width="40" height="26" loading="lazy" onerror="this.style.visibility='hidden'">`;
    return `<span class="hfs__blog-icon" aria-hidden="true">▤</span>`;
  }

  function render(root,query,activeIndex,articles=[],articlesPending=false){
    const panel=root.querySelector('[data-hfs-results]');
    if(!panel)return [];
    const search=api();
    const q=query.trim();
    const actions=[];
    if(!q){
      panel.innerHTML=`<div class="hfs__empty"><p>Search a country, team, product, or blog</p><div class="hfs__hints">${search.HINTS.map((hint,index)=>`<a class="hfs__hint" href="${search.escapeHtml(search.searchUrl(hint.query,root.dataset.search||'/search'))}" data-hfs-action="hint" data-hfs-query="${search.escapeHtml(hint.query)}" data-hfs-index="${index}">${search.escapeHtml(hint.label)}</a>`).join('')}</div></div>`;
      search.HINTS.forEach(hint=>actions.push({type:'hint',query:hint.query}));
      return actions;
    }
    const {pair,flags,products}=search.resultsFor(q,8,4);
    let html='';
    if(pair){
      const index=actions.length;
      actions.push({type:'pair',items:pair});
      html+=`<div class="hfs__row hfs__row--pair${index===activeIndex?' is-active':''}" data-hfs-index="${index}"><button type="button" class="hfs__row-main" data-hfs-action="results" data-hfs-index="${index}"><span class="hfs__thumbs">${thumbMarkup(pair[0].thumb,pair[0].type==='sports')}${thumbMarkup(pair[1].thumb,pair[1].type==='sports')}</span><span class="hfs__copy"><strong>${search.escapeHtml(pair[0].label)} + ${search.escapeHtml(pair[1].label)}</strong><small>Custom 2-in-1 flag</small></span></button>${designButton(index)}</div>`;
    }
    if(flags.length){
      html+=`<h3 class="hfs__heading">Flags</h3><div class="hfs__list">${flags.map(item=>{
        const index=actions.length;
        actions.push({type:'flag',item,query:item.label});
        return `<div class="hfs__row${index===activeIndex?' is-active':''}" data-hfs-index="${index}"><button type="button" class="hfs__row-main" data-hfs-action="results" data-hfs-index="${index}">${thumbMarkup(item.thumb,item.type==='sports')}<span class="hfs__copy"><strong>${search.escapeHtml(item.label)}</strong><small>${search.escapeHtml(item.meta)}</small></span></button>${designButton(index)}</div>`;
      }).join('')}</div>`;
    }
    if(articles.length){
      html+=`<h3 class="hfs__heading">Blogs</h3><div class="hfs__list">${articles.map(item=>{
        const index=actions.length;
        actions.push({type:'article',item});
        return `<a class="hfs__row${index===activeIndex?' is-active':''}" href="${search.escapeHtml(item.url)}" data-hfs-action="article" data-hfs-index="${index}">${articleThumb(item,search)}<span class="hfs__copy"><strong>${search.escapeHtml(item.title)}</strong><small>${search.escapeHtml(item.blog||'Blog')}</small></span></a>`;
      }).join('')}</div>`;
    }
    if(products.length){
      html+=`<h3 class="hfs__heading">Products</h3><div class="hfs__list">${products.map(item=>{
        const index=actions.length;
        actions.push({type:'product',item});
        return `<button type="button" class="hfs__row${index===activeIndex?' is-active':''}" data-hfs-action="product" data-hfs-index="${index}"><span class="hfs__product-icon" aria-hidden="true">▣</span><span class="hfs__copy"><strong>${search.escapeHtml(item.label)}</strong><small>Shop this product</small></span></button>`;
      }).join('')}</div>`;
    }
    if(html)html+=`<button type="button" class="hfs__all" data-hfs-action="all">View all results for “${search.escapeHtml(q)}”</button>`;
    if(!html&&articlesPending){
      panel.innerHTML=`<div class="hfs__empty"><p>Searching…</p></div>`;
      return actions;
    }
    panel.innerHTML=html||`<div class="hfs__empty"><p>No matches for “${search.escapeHtml(q)}”.</p><p>Try Ireland, Jamaica, Yankees, or hoodie.</p></div>`;
    return actions;
  }

  function runAction(root,action,via){
    if(!action)return;
    const search=api();
    if(action.type==='hint'){
      goResults(root,action.query);
      return;
    }
    if(via==='design'||action.type==='pair'&&via==='design'){
      const items=action.items||(action.item?[action.item]:[]);
      closeSearch(root);
      search.openDesigner(items,root.dataset.home||'/');
      return;
    }
    if(action.type==='product'){
      closeSearch(root);
      window.location.assign(search.productUrl(action.item,root));
      return;
    }
    if(action.type==='article'){
      closeSearch(root);
      window.location.assign(action.item.url);
      return;
    }
    goResults(root,action.query||root.querySelector('[data-hfs-input]')?.value||'');
  }

  function initRoot(root){
    if(!root||root.dataset.ready||!api())return;
    root.dataset.ready='1';
    const input=root.querySelector('[data-hfs-input]');
    const panel=root.querySelector('[data-hfs-results]');
    if(!input||!panel)return;
    let activeIndex=0;
    const paintActive=()=>{
      panel.querySelectorAll('[data-hfs-index]').forEach(row=>row.classList.toggle('is-active',Number(row.dataset.hfsIndex)===activeIndex));
    };
    const refresh=()=>{
      root._hfsActions=render(root,input.value,activeIndex,root._hfsArticles||[],root._hfsArticlesPending);
      const count=root._hfsActions.length;
      if(activeIndex>=count)activeIndex=Math.max(0,count-1);
      paintActive();
    };
    const scheduleArticles=()=>{
      const q=input.value.trim();
      if(root._hfsArticleTimer)clearTimeout(root._hfsArticleTimer);
      root._hfsArticleAbort?.abort();
      if(!q){
        root._hfsArticles=[];
        root._hfsArticlesPending=false;
        return;
      }
      const local=api().bestArticles(q,4);
      root._hfsArticles=local;
      root._hfsArticlesPending=true;
      const ac=new AbortController();
      root._hfsArticleAbort=ac;
      root._hfsArticleTimer=setTimeout(()=>{
        api().fetchArticles(q,4,{root,signal:ac.signal}).then(remote=>{
          if(ac.signal.aborted||input.value.trim()!==q)return;
          root._hfsArticles=api().mergeArticles(remote,local,4);
          root._hfsArticlesPending=false;
          refresh();
        }).catch(()=>{
          if(ac.signal.aborted)return;
          root._hfsArticlesPending=false;
          refresh();
        });
      },160);
    };
    root._hfsActions=render(root,'',0);
    input.addEventListener('input',()=>{activeIndex=0;scheduleArticles();refresh();});
    input.addEventListener('keydown',event=>{
      const count=root._hfsActions?.length||0;
      if(event.key==='ArrowDown'&&count){event.preventDefault();activeIndex=(activeIndex+1)%count;paintActive();}
      else if(event.key==='ArrowUp'&&count){event.preventDefault();activeIndex=(activeIndex-1+count)%count;paintActive();}
      else if(event.key==='Enter'){
        event.preventDefault();
        const action=root._hfsActions?.[activeIndex];
        if(action?.type==='hint'||action?.type==='product'||action?.type==='article')runAction(root,action);
        else goResults(root,input.value);
      }
    });
    panel.addEventListener('click',event=>{
      const hint=event.target.closest('[data-hfs-action="hint"]');
      if(hint){
        event.preventDefault();
        event.stopPropagation();
        goResults(root,hint.dataset.hfsQuery||hint.textContent,hint.getAttribute('href'));
        return;
      }
      const article=event.target.closest('[data-hfs-action="article"]');
      if(article){
        event.preventDefault();
        event.stopPropagation();
        runAction(root,root._hfsActions?.[Number(article.dataset.hfsIndex)]);
        return;
      }
      const all=event.target.closest('[data-hfs-action="all"]');
      if(all){event.preventDefault();event.stopPropagation();goResults(root,input.value);return;}
      const design=event.target.closest('[data-hfs-action="design"]');
      if(design){event.preventDefault();event.stopPropagation();runAction(root,root._hfsActions?.[Number(design.dataset.hfsIndex)],'design');return;}
      const row=event.target.closest('[data-hfs-index]');
      if(!row)return;
      event.preventDefault();
      event.stopPropagation();
      runAction(root,root._hfsActions?.[Number(row.dataset.hfsIndex)]);
    });
    panel.addEventListener('mouseover',event=>{
      const row=event.target.closest('[data-hfs-index]');
      if(!row)return;
      activeIndex=Number(row.dataset.hfsIndex);
      paintActive();
    });
    const details=root.closest('details');
    details?.addEventListener('toggle',()=>{
      if(!details.open)return;
      const header=document.querySelector('.section-header');
      header?.classList.remove('shopify-section-header-hidden');
      if(header)document.documentElement.style.setProperty('--header-height',`${header.offsetHeight}px`);
      input.value='';
      activeIndex=0;
      if(root._hfsArticleTimer)clearTimeout(root._hfsArticleTimer);
      root._hfsArticleAbort?.abort();
      root._hfsArticles=[];
      root._hfsArticlesPending=false;
      refresh();
      requestAnimationFrame(()=>input.focus());
    });
  }

  function init(){
    document.querySelectorAll('[data-header-flag-search]').forEach(initRoot);
  }

  document.addEventListener('click',event=>{
    const hint=event.target.closest('[data-header-flag-search] [data-hfs-action="hint"]');
    if(hint){
      const root=hint.closest('[data-header-flag-search]');
      event.preventDefault();
      event.stopPropagation();
      goResults(root,hint.dataset.hfsQuery||hint.textContent,hint.getAttribute('href'));
      return;
    }
    const article=event.target.closest('[data-header-flag-search] [data-hfs-action="article"]');
    if(!article)return;
    const root=article.closest('[data-header-flag-search]');
    event.preventDefault();
    event.stopPropagation();
    runAction(root,root._hfsActions?.[Number(article.dataset.hfsIndex)]||{type:'article',item:{url:article.getAttribute('href')}});
  },true);

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
